import http from "@/api.js";

export default {
    data: () => ({
        participantapi: "/meetings/participant/",
        participantdata: [],
        participant_ready: 0,
    }),
    props: {
        participant: { type: [String, Object], },
        participants: { type: Object, },
    },
    computed: {
        list_participants() {
            return [this.participantdata.me].concat(this.participantdata.representative).concat(this.participantdata.proxy);
        },
    },
    methods: {
        participantUrl(group, uid, suffix){
            suffix = suffix || "";
            const url = "/api/"+group+this.participantapi;
            return uid ? url+uid+"/"+suffix : url+suffix;
        },
        loadParticipants(meeting){
            this.participant_ready = 1;
            const ppuid = this.participant?.uid ? this.participant?.uid + "/" : "";
            http.get(this.participantUrl(this.group, meeting, "my_list_of_participants/" + ppuid)).then(response => {
                this.participantdata = response.data;
                this.participant_ready = 2;
            });
        },
    }
}
